import zIndex from "@material-ui/core/styles/zIndex"

export const Z_INDEX_ABOVE_MODAL = zIndex.modal + 1
export const Z_INDEX_APP_BAR = zIndex.appBar
